const Ke = (e) => {
  const n = "=".repeat((4 - e.length % 4) % 4), t = (e + n).replace(/-/g, "+").replace(/_/g, "/"), r = window.atob(t), o = new Uint8Array(r.length);
  for (let i = 0; i < r.length; ++i)
    o[i] = r.charCodeAt(i);
  return o;
}, se = ({ publicKey: e }) => ({ getSubscription: async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window))
    throw {
      errorCode: "ServiceWorkerAndPushManagerNotSupported"
    };
  const t = await navigator.serviceWorker.ready;
  if (!t.pushManager)
    throw { errorCode: "PushManagerUnavailable" };
  const r = await t.pushManager.getSubscription();
  if (r)
    return r;
  const o = Ke(e);
  return await t.pushManager.subscribe({
    applicationServerKey: o,
    userVisibleOnly: !0
  });
} });
var ve = function() {
  return ve = Object.assign || function(n) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (n[i] = t[i]);
    }
    return n;
  }, ve.apply(this, arguments);
};
function C(e, n, t, r) {
  function o(i) {
    return i instanceof t ? i : new t(function(a) {
      a(i);
    });
  }
  return new (t || (t = Promise))(function(i, a) {
    function c(f) {
      try {
        l(r.next(f));
      } catch (u) {
        a(u);
      }
    }
    function s(f) {
      try {
        l(r.throw(f));
      } catch (u) {
        a(u);
      }
    }
    function l(f) {
      f.done ? i(f.value) : o(f.value).then(c, s);
    }
    l((r = r.apply(e, n || [])).next());
  });
}
function F(e, n) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a;
  return a = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function c(l) {
    return function(f) {
      return s([l, f]);
    };
  }
  function s(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, l[0] && (t = 0)), t; )
      try {
        if (r = 1, o && (i = l[0] & 2 ? o.return : l[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, l[1])).done)
          return i;
        switch (o = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
          case 0:
          case 1:
            i = l;
            break;
          case 4:
            return t.label++, { value: l[1], done: !1 };
          case 5:
            t.label++, o = l[1], l = [0];
            continue;
          case 7:
            l = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              t = 0;
              continue;
            }
            if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
              t.label = l[1];
              break;
            }
            if (l[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = l;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(l);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        l = n.call(e, t);
      } catch (f) {
        l = [6, f], o = 0;
      } finally {
        r = i = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function Ce(e, n, t) {
  if (t || arguments.length === 2)
    for (var r = 0, o = n.length, i; r < o; r++)
      (i || !(r in n)) && (i || (i = Array.prototype.slice.call(n, 0, r)), i[r] = n[r]);
  return e.concat(i || Array.prototype.slice.call(n));
}
var Fe = "4.2.1";
function K(e, n) {
  return new Promise(function(t) {
    return setTimeout(t, e, n);
  });
}
function ie() {
  return K(0);
}
function Qe(e, n) {
  n === void 0 && (n = 1 / 0);
  var t = window.requestIdleCallback;
  return t ? new Promise(function(r) {
    return t.call(window, function() {
      return r();
    }, { timeout: n });
  }) : K(Math.min(e, n));
}
function We(e) {
  return !!e && typeof e.then == "function";
}
function ye(e, n) {
  try {
    var t = e();
    We(t) ? t.then(function(r) {
      return n(!0, r);
    }, function(r) {
      return n(!1, r);
    }) : n(!0, t);
  } catch (r) {
    n(!1, r);
  }
}
function we(e, n, t) {
  return t === void 0 && (t = 16), C(this, void 0, void 0, function() {
    var r, o, i, a;
    return F(this, function(c) {
      switch (c.label) {
        case 0:
          r = Array(e.length), o = Date.now(), i = 0, c.label = 1;
        case 1:
          return i < e.length ? (r[i] = n(e[i], i), a = Date.now(), a >= o + t ? (o = a, [4, K(0)]) : [3, 3]) : [3, 4];
        case 2:
          c.sent(), c.label = 3;
        case 3:
          return ++i, [3, 1];
        case 4:
          return [2, r];
      }
    });
  });
}
function oe(e) {
  e.then(void 0, function() {
  });
}
function _e(e, n) {
  for (var t = 0, r = e.length; t < r; ++t)
    if (e[t] === n)
      return !0;
  return !1;
}
function qe(e, n) {
  return !_e(e, n);
}
function pe(e) {
  return parseInt(e);
}
function j(e) {
  return parseFloat(e);
}
function H(e, n) {
  return typeof e == "number" && isNaN(e) ? n : e;
}
function D(e) {
  return e.reduce(function(n, t) {
    return n + (t ? 1 : 0);
  }, 0);
}
function Re(e, n) {
  if (n === void 0 && (n = 1), Math.abs(n) >= 1)
    return Math.round(e / n) * n;
  var t = 1 / n;
  return Math.round(e * t) / t;
}
function $e(e) {
  for (var n, t, r = "Unexpected syntax '".concat(e, "'"), o = /^\s*([a-z-]*)(.*)$/i.exec(e), i = o[1] || void 0, a = {}, c = /([.:#][\w-]+|\[.+?\])/gi, s = function(h, p) {
    a[h] = a[h] || [], a[h].push(p);
  }; ; ) {
    var l = c.exec(o[2]);
    if (!l)
      break;
    var f = l[0];
    switch (f[0]) {
      case ".":
        s("class", f.slice(1));
        break;
      case "#":
        s("id", f.slice(1));
        break;
      case "[": {
        var u = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(f);
        if (u)
          s(u[1], (t = (n = u[4]) !== null && n !== void 0 ? n : u[5]) !== null && t !== void 0 ? t : "");
        else
          throw new Error(r);
        break;
      }
      default:
        throw new Error(r);
    }
  }
  return [i, a];
}
function en(e) {
  for (var n = new Uint8Array(e.length), t = 0; t < e.length; t++) {
    var r = e.charCodeAt(t);
    if (r > 127)
      return new TextEncoder().encode(e);
    n[t] = r;
  }
  return n;
}
function z(e, n) {
  var t = e[0] >>> 16, r = e[0] & 65535, o = e[1] >>> 16, i = e[1] & 65535, a = n[0] >>> 16, c = n[0] & 65535, s = n[1] >>> 16, l = n[1] & 65535, f = 0, u = 0, h = 0, p = 0;
  p += i + l, h += p >>> 16, p &= 65535, h += o + s, u += h >>> 16, h &= 65535, u += r + c, f += u >>> 16, u &= 65535, f += t + a, f &= 65535, e[0] = f << 16 | u, e[1] = h << 16 | p;
}
function G(e, n) {
  var t = e[0] >>> 16, r = e[0] & 65535, o = e[1] >>> 16, i = e[1] & 65535, a = n[0] >>> 16, c = n[0] & 65535, s = n[1] >>> 16, l = n[1] & 65535, f = 0, u = 0, h = 0, p = 0;
  p += i * l, h += p >>> 16, p &= 65535, h += o * l, u += h >>> 16, h &= 65535, h += i * s, u += h >>> 16, h &= 65535, u += r * l, f += u >>> 16, u &= 65535, u += o * s, f += u >>> 16, u &= 65535, u += i * c, f += u >>> 16, u &= 65535, f += t * l + r * s + o * c + i * a, f &= 65535, e[0] = f << 16 | u, e[1] = h << 16 | p;
}
function Q(e, n) {
  var t = e[0];
  n %= 64, n === 32 ? (e[0] = e[1], e[1] = t) : n < 32 ? (e[0] = t << n | e[1] >>> 32 - n, e[1] = e[1] << n | t >>> 32 - n) : (n -= 32, e[0] = e[1] << n | t >>> 32 - n, e[1] = t << n | e[1] >>> 32 - n);
}
function Z(e, n) {
  n %= 64, n !== 0 && (n < 32 ? (e[0] = e[1] >>> 32 - n, e[1] = e[1] << n) : (e[0] = e[1] << n - 32, e[1] = 0));
}
function L(e, n) {
  e[0] ^= n[0], e[1] ^= n[1];
}
var nn = [4283543511, 3981806797], tn = [3301882366, 444984403];
function Se(e) {
  var n = [0, e[0] >>> 1];
  L(e, n), G(e, nn), n[1] = e[0] >>> 1, L(e, n), G(e, tn), n[1] = e[0] >>> 1, L(e, n);
}
var ee = [2277735313, 289559509], ne = [1291169091, 658871167], ke = [0, 5], rn = [0, 1390208809], on = [0, 944331445];
function an(e, n) {
  var t = en(e);
  n = n || 0;
  var r = [0, t.length], o = r[1] % 16, i = r[1] - o, a = [0, n], c = [0, n], s = [0, 0], l = [0, 0], f;
  for (f = 0; f < i; f = f + 16)
    s[0] = t[f + 4] | t[f + 5] << 8 | t[f + 6] << 16 | t[f + 7] << 24, s[1] = t[f] | t[f + 1] << 8 | t[f + 2] << 16 | t[f + 3] << 24, l[0] = t[f + 12] | t[f + 13] << 8 | t[f + 14] << 16 | t[f + 15] << 24, l[1] = t[f + 8] | t[f + 9] << 8 | t[f + 10] << 16 | t[f + 11] << 24, G(s, ee), Q(s, 31), G(s, ne), L(a, s), Q(a, 27), z(a, c), G(a, ke), z(a, rn), G(l, ne), Q(l, 33), G(l, ee), L(c, l), Q(c, 31), z(c, a), G(c, ke), z(c, on);
  s[0] = 0, s[1] = 0, l[0] = 0, l[1] = 0;
  var u = [0, 0];
  switch (o) {
    case 15:
      u[1] = t[f + 14], Z(u, 48), L(l, u);
    case 14:
      u[1] = t[f + 13], Z(u, 40), L(l, u);
    case 13:
      u[1] = t[f + 12], Z(u, 32), L(l, u);
    case 12:
      u[1] = t[f + 11], Z(u, 24), L(l, u);
    case 11:
      u[1] = t[f + 10], Z(u, 16), L(l, u);
    case 10:
      u[1] = t[f + 9], Z(u, 8), L(l, u);
    case 9:
      u[1] = t[f + 8], L(l, u), G(l, ne), Q(l, 33), G(l, ee), L(c, l);
    case 8:
      u[1] = t[f + 7], Z(u, 56), L(s, u);
    case 7:
      u[1] = t[f + 6], Z(u, 48), L(s, u);
    case 6:
      u[1] = t[f + 5], Z(u, 40), L(s, u);
    case 5:
      u[1] = t[f + 4], Z(u, 32), L(s, u);
    case 4:
      u[1] = t[f + 3], Z(u, 24), L(s, u);
    case 3:
      u[1] = t[f + 2], Z(u, 16), L(s, u);
    case 2:
      u[1] = t[f + 1], Z(u, 8), L(s, u);
    case 1:
      u[1] = t[f], L(s, u), G(s, ee), Q(s, 31), G(s, ne), L(a, s);
  }
  return L(a, r), L(c, r), z(a, c), z(c, a), Se(a), Se(c), z(a, c), z(c, a), ("00000000" + (a[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (a[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (c[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (c[1] >>> 0).toString(16)).slice(-8);
}
function cn(e) {
  var n;
  return ve({ name: e.name, message: e.message, stack: (n = e.stack) === null || n === void 0 ? void 0 : n.split(`
`) }, e);
}
function sn(e) {
  return /^function\s.*?\{\s*\[native code]\s*}$/.test(String(e));
}
function un(e) {
  return typeof e != "function";
}
function ln(e, n) {
  var t = new Promise(function(r) {
    var o = Date.now();
    ye(e.bind(null, n), function() {
      for (var i = [], a = 0; a < arguments.length; a++)
        i[a] = arguments[a];
      var c = Date.now() - o;
      if (!i[0])
        return r(function() {
          return { error: i[1], duration: c };
        });
      var s = i[1];
      if (un(s))
        return r(function() {
          return { value: s, duration: c };
        });
      r(function() {
        return new Promise(function(l) {
          var f = Date.now();
          ye(s, function() {
            for (var u = [], h = 0; h < arguments.length; h++)
              u[h] = arguments[h];
            var p = c + Date.now() - f;
            if (!u[0])
              return l({ error: u[1], duration: p });
            l({ value: u[1], duration: p });
          });
        });
      });
    });
  });
  return oe(t), function() {
    return t.then(function(o) {
      return o();
    });
  };
}
function fn(e, n, t) {
  var r = Object.keys(e).filter(function(i) {
    return qe(t, i);
  }), o = we(r, function(i) {
    return ln(e[i], n);
  });
  return oe(o), function() {
    return C(this, void 0, void 0, function() {
      var a, c, s, l, f;
      return F(this, function(u) {
        switch (u.label) {
          case 0:
            return [4, o];
          case 1:
            return a = u.sent(), [4, we(a, function(h) {
              var p = h();
              return oe(p), p;
            })];
          case 2:
            return c = u.sent(), [
              4,
              Promise.all(c)
            ];
          case 3:
            for (s = u.sent(), l = {}, f = 0; f < r.length; ++f)
              l[r[f]] = s[f];
            return [2, l];
        }
      });
    });
  };
}
function De() {
  var e = window, n = navigator;
  return D([
    "MSCSSMatrix" in e,
    "msSetImmediate" in e,
    "msIndexedDB" in e,
    "msMaxTouchPoints" in n,
    "msPointerEnabled" in n
  ]) >= 4;
}
function dn() {
  var e = window, n = navigator;
  return D(["msWriteProfilerMark" in e, "MSStream" in e, "msLaunchUri" in n, "msSaveBlob" in n]) >= 3 && !De();
}
function ge() {
  var e = window, n = navigator;
  return D([
    "webkitPersistentStorage" in n,
    "webkitTemporaryStorage" in n,
    n.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in e,
    "BatteryManager" in e,
    "webkitMediaStream" in e,
    "webkitSpeechGrammar" in e
  ]) >= 5;
}
function J() {
  var e = window, n = navigator;
  return D([
    "ApplePayError" in e,
    "CSSPrimitiveValue" in e,
    "Counter" in e,
    n.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in n,
    "WebKitMediaKeys" in e
  ]) >= 4;
}
function be() {
  var e = window, n = e.HTMLElement, t = e.Document;
  return D([
    "safari" in e,
    !("ongestureend" in e),
    !("TouchEvent" in e),
    !("orientation" in e),
    n && !("autocapitalize" in n.prototype),
    t && "pointerLockElement" in t.prototype
  ]) >= 4;
}
function ae() {
  var e = window;
  return sn(e.print) ? D([
    String(e.browser) === "[object WebPageNamespace]",
    "MicrodataExtractor" in e
  ]) >= 1 : !1;
}
function Ze() {
  var e, n, t = window;
  return D([
    "buildID" in navigator,
    "MozAppearance" in ((n = (e = document.documentElement) === null || e === void 0 ? void 0 : e.style) !== null && n !== void 0 ? n : {}),
    "onmozfullscreenchange" in t,
    "mozInnerScreenX" in t,
    "CSSMozDocumentRule" in t,
    "CanvasCaptureMediaStream" in t
  ]) >= 4;
}
function vn() {
  var e = window;
  return D([
    !("MediaSettingsRange" in e),
    "RTCEncodedAudioFrame" in e,
    "" + e.Intl == "[object Intl]",
    "" + e.Reflect == "[object Reflect]"
  ]) >= 3;
}
function mn() {
  var e = window;
  return D([
    "DOMRectList" in e,
    "RTCPeerConnectionIceEvent" in e,
    "SVGGeometryElement" in e,
    "ontransitioncancel" in e
  ]) >= 3;
}
function ce() {
  var e = window, n = navigator, t = e.CSS, r = e.HTMLButtonElement;
  return D([
    !("getStorageUpdates" in n),
    r && "popover" in r.prototype,
    "CSSCounterStyleRule" in e,
    t.supports("font-size-adjust: ex-height 0.5"),
    t.supports("text-transform: full-width")
  ]) >= 4;
}
function hn() {
  if (navigator.platform === "iPad")
    return !0;
  var e = screen, n = e.width / e.height;
  return D([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    n > 0.65 && n < 1.53
  ]) >= 2;
}
function pn() {
  var e = document;
  return e.fullscreenElement || e.msFullscreenElement || e.mozFullScreenElement || e.webkitFullscreenElement || null;
}
function gn() {
  var e = document;
  return (e.exitFullscreen || e.msExitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen).call(e);
}
function Ge() {
  var e = ge(), n = Ze(), t = window, r = navigator, o = "connection";
  return e ? D([
    !("SharedWorker" in t),
    r[o] && "ontypechange" in r[o],
    !("sinkId" in new window.Audio())
  ]) >= 2 : n ? D(["onorientationchange" in t, "orientation" in t, /android/i.test(navigator.appVersion)]) >= 2 : !1;
}
function Te(e, n, t) {
  var r, o, i;
  return t === void 0 && (t = 50), C(this, void 0, void 0, function() {
    var a, c;
    return F(this, function(s) {
      switch (s.label) {
        case 0:
          a = document, s.label = 1;
        case 1:
          return a.body ? [3, 3] : [4, K(t)];
        case 2:
          return s.sent(), [3, 1];
        case 3:
          c = a.createElement("iframe"), s.label = 4;
        case 4:
          return s.trys.push([4, , 10, 11]), [4, new Promise(function(l, f) {
            var u = !1, h = function() {
              u = !0, l();
            }, p = function(b) {
              u = !0, f(b);
            };
            c.onload = h, c.onerror = p;
            var A = c.style;
            A.setProperty("display", "block", "important"), A.position = "absolute", A.top = "0", A.left = "0", A.visibility = "hidden", n && "srcdoc" in c ? c.srcdoc = n : c.src = "about:blank", a.body.appendChild(c);
            var I = function() {
              var b, S;
              u || (((S = (b = c.contentWindow) === null || b === void 0 ? void 0 : b.document) === null || S === void 0 ? void 0 : S.readyState) === "complete" ? h() : setTimeout(I, 10));
            };
            I();
          })];
        case 5:
          s.sent(), s.label = 6;
        case 6:
          return !((o = (r = c.contentWindow) === null || r === void 0 ? void 0 : r.document) === null || o === void 0) && o.body ? [3, 8] : [4, K(t)];
        case 7:
          return s.sent(), [3, 6];
        case 8:
          return [4, e(c, c.contentWindow)];
        case 9:
          return [2, s.sent()];
        case 10:
          return (i = c.parentNode) === null || i === void 0 || i.removeChild(c), [7];
        case 11:
          return [2];
      }
    });
  });
}
function bn(e) {
  for (var n = $e(e), t = n[0], r = n[1], o = document.createElement(t ?? "div"), i = 0, a = Object.keys(r); i < a.length; i++) {
    var c = a[i], s = r[c].join(" ");
    c === "style" ? yn(o.style, s) : o.setAttribute(c, s);
  }
  return o;
}
function yn(e, n) {
  for (var t = 0, r = n.split(";"); t < r.length; t++) {
    var o = r[t], i = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(o);
    if (i) {
      var a = i[1], c = i[2], s = i[4];
      e.setProperty(a, c, s || "");
    }
  }
}
function wn() {
  return new Promise(function(e) {
    var n = document, t = "visibilitychange", r = function() {
      n.hidden || (n.removeEventListener(t, r), e());
    };
    n.addEventListener(t, r), r();
  });
}
var te = 44100, Sn = 4e4, kn = 6.2;
function Ln() {
  return C(this, void 0, void 0, function() {
    var e;
    return F(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, In()];
        case 1:
          return e = n.sent(), [2, function() {
            var t = e();
            return Mn(t, kn);
          }];
      }
    });
  });
}
function In() {
  return C(this, void 0, void 0, function() {
    var e, n, t;
    return F(this, function(r) {
      switch (r.label) {
        case 0:
          return n = wn().then(function() {
            return K(500);
          }), t = xn().then(function(o) {
            return e = [!0, o];
          }, function(o) {
            return e = [!1, o];
          }), [4, Promise.race([n, t])];
        case 1:
          return r.sent(), [2, function() {
            if (!e)
              return -3;
            if (!e[0])
              throw e[1];
            return e[1];
          }];
      }
    });
  });
}
function xn() {
  return C(this, void 0, void 0, function() {
    var e, n, t, r, o, i, a;
    return F(this, function(c) {
      switch (c.label) {
        case 0:
          return e = window, n = e.OfflineAudioContext || e.webkitOfflineAudioContext, n ? Pn() ? [2, -1] : [4, Vn(n)] : [2, -2];
        case 1:
          return t = c.sent(), t ? (r = new n(1, t.length - 1 + Sn, te), o = r.createBufferSource(), o.buffer = t, o.loop = !0, o.loopStart = (t.length - 1) / te, o.loopEnd = t.length / te, o.connect(r.destination), o.start(), [4, je(r)]) : [2, -3];
        case 2:
          return i = c.sent(), i ? (a = En(t, i.getChannelData(0).subarray(t.length - 1)), [2, Math.abs(a)]) : [2, -3];
      }
    });
  });
}
function Pn() {
  return J() && !be() && !mn();
}
function Vn(e) {
  return C(this, void 0, void 0, function() {
    var n, t, r, o, i;
    return F(this, function(a) {
      switch (a.label) {
        case 0:
          return n = 3395, t = new e(1, n + 1, te), r = t.createOscillator(), r.type = "square", r.frequency.value = 1e3, o = t.createDynamicsCompressor(), o.threshold.value = -70, o.knee.value = 40, o.ratio.value = 12, o.attack.value = 0, o.release.value = 0.25, i = t.createBiquadFilter(), i.type = "allpass", i.frequency.value = 5.239622852977861, i.Q.value = 0.1, r.connect(o), o.connect(i), i.connect(t.destination), r.start(0), [4, je(t)];
        case 1:
          return [2, a.sent()];
      }
    });
  });
}
function je(e) {
  return new Promise(function(n, t) {
    var r = 200, o = 25;
    e.oncomplete = function(a) {
      return n(a.renderedBuffer);
    };
    var i = function() {
      try {
        var a = e.startRendering();
        We(a) && oe(a), e.state === "suspended" && (document.hidden || o--, o > 0 ? setTimeout(i, r) : n(null));
      } catch (c) {
        t(c);
      }
    };
    i();
  });
}
function En(e, n) {
  for (var t = void 0, r = !1, o = 0; o < n.length; o += Math.floor(n.length / 10))
    if (n[o] !== 0) {
      if (t === void 0)
        t = n[o];
      else if (t !== n[o]) {
        r = !0;
        break;
      }
    }
  return t === void 0 ? t = e.getChannelData(0)[e.length - 1] : r && (t = An(n)), t;
}
function An(e) {
  for (var n = 1 / 0, t = -1 / 0, r = 0; r < e.length; r++) {
    var o = e[r];
    o !== 0 && (o < n && (n = o), o > t && (t = o));
  }
  return (n + t) / 2;
}
function Mn(e, n) {
  if (e === 0)
    return e;
  var t = Math.floor(Math.log10(Math.abs(e))), r = t - Math.floor(n) + 1, o = Math.pow(10, -r) * (n * 10 % 10 || 1);
  return Math.round(e * o) / o;
}
var Cn = "mmMwWLliI0O&1", Fn = "48px", _ = ["monospace", "sans-serif", "serif"], Le = [
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function Wn() {
  var e = this;
  return Te(function(n, t) {
    var r = t.document;
    return C(e, void 0, void 0, function() {
      var o, i, a, c, s, l, f, u, h, p, A, I;
      return F(this, function(b) {
        switch (b.label) {
          case 0:
            return o = r.body, o.style.fontSize = Fn, i = r.createElement("div"), i.style.setProperty("visibility", "hidden", "important"), a = {}, c = {}, s = function(S) {
              var x = r.createElement("span"), V = x.style;
              return V.position = "absolute", V.top = "0", V.left = "0", V.fontFamily = S, x.textContent = Cn, i.appendChild(x), x;
            }, l = function(S, x) {
              return s("'".concat(S, "',").concat(x));
            }, f = function() {
              return _.map(s);
            }, u = function() {
              for (var S = {}, x = function(Y) {
                S[Y] = _.map(function(X) {
                  return l(Y, X);
                });
              }, V = 0, E = Le; V < E.length; V++) {
                var N = E[V];
                x(N);
              }
              return S;
            }, h = function(S) {
              return _.some(function(x, V) {
                return S[V].offsetWidth !== a[x] || S[V].offsetHeight !== c[x];
              });
            }, p = f(), A = u(), o.appendChild(i), [
              4,
              ie()
            ];
          case 1:
            for (b.sent(), I = 0; I < _.length; I++)
              a[_[I]] = p[I].offsetWidth, c[_[I]] = p[I].offsetHeight;
            return [2, Le.filter(function(S) {
              return h(A[S]);
            })];
        }
      });
    });
  });
}
function Rn() {
  var e = navigator.plugins;
  if (!!e) {
    for (var n = [], t = 0; t < e.length; ++t) {
      var r = e[t];
      if (!!r) {
        for (var o = [], i = 0; i < r.length; ++i) {
          var a = r[i];
          o.push({
            type: a.type,
            suffixes: a.suffixes
          });
        }
        n.push({
          name: r.name,
          description: r.description,
          mimeTypes: o
        });
      }
    }
    return n;
  }
}
function Dn() {
  return Zn(Hn());
}
function Zn(e) {
  return C(this, void 0, void 0, function() {
    var n, t, r, o, i, a, c;
    return F(this, function(s) {
      switch (s.label) {
        case 0:
          return n = !1, o = Gn(), i = o[0], a = o[1], Tn(i, a) ? [3, 1] : (t = r = "unsupported", [3, 4]);
        case 1:
          return n = jn(a), e ? (t = r = "skipped", [3, 4]) : [3, 2];
        case 2:
          return [4, Nn(i, a)];
        case 3:
          c = s.sent(), t = c[0], r = c[1], s.label = 4;
        case 4:
          return [2, { winding: n, geometry: t, text: r }];
      }
    });
  });
}
function Gn() {
  var e = document.createElement("canvas");
  return e.width = 1, e.height = 1, [e, e.getContext("2d")];
}
function Tn(e, n) {
  return !!(n && e.toDataURL);
}
function jn(e) {
  return e.rect(0, 0, 10, 10), e.rect(2, 2, 6, 6), !e.isPointInPath(5, 5, "evenodd");
}
function Nn(e, n) {
  return C(this, void 0, void 0, function() {
    var t, r, o;
    return F(this, function(i) {
      switch (i.label) {
        case 0:
          return Yn(e, n), [4, ie()];
        case 1:
          return i.sent(), t = ue(e), r = ue(e), t !== r ? [2, ["unstable", "unstable"]] : (Xn(e, n), [4, ie()]);
        case 2:
          return i.sent(), o = ue(e), [2, [t, o]];
      }
    });
  });
}
function Yn(e, n) {
  e.width = 240, e.height = 60, n.textBaseline = "alphabetic", n.fillStyle = "#f60", n.fillRect(100, 1, 62, 20), n.fillStyle = "#069", n.font = '11pt "Times New Roman"';
  var t = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835));
  n.fillText(t, 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.2)", n.font = "18pt Arial", n.fillText(t, 4, 45);
}
function Xn(e, n) {
  e.width = 122, e.height = 110, n.globalCompositeOperation = "multiply";
  for (var t = 0, r = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; t < r.length; t++) {
    var o = r[t], i = o[0], a = o[1], c = o[2];
    n.fillStyle = i, n.beginPath(), n.arc(a, c, 40, 0, Math.PI * 2, !0), n.closePath(), n.fill();
  }
  n.fillStyle = "#f9c", n.arc(60, 60, 60, 0, Math.PI * 2, !0), n.arc(60, 60, 20, 0, Math.PI * 2, !0), n.fill("evenodd");
}
function ue(e) {
  return e.toDataURL();
}
function Hn() {
  return J() && ce() && ae();
}
function Bn() {
  var e = navigator, n = 0, t;
  e.maxTouchPoints !== void 0 ? n = pe(e.maxTouchPoints) : e.msMaxTouchPoints !== void 0 && (n = e.msMaxTouchPoints);
  try {
    document.createEvent("TouchEvent"), t = !0;
  } catch {
    t = !1;
  }
  var r = "ontouchstart" in window;
  return {
    maxTouchPoints: n,
    touchEvent: t,
    touchStart: r
  };
}
function Un() {
  return navigator.oscpu;
}
function zn() {
  var e = navigator, n = [], t = e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
  if (t !== void 0 && n.push([t]), Array.isArray(e.languages))
    ge() && vn() || n.push(e.languages);
  else if (typeof e.languages == "string") {
    var r = e.languages;
    r && n.push(r.split(","));
  }
  return n;
}
function Jn() {
  return window.screen.colorDepth;
}
function On() {
  return H(j(navigator.deviceMemory), void 0);
}
function Kn() {
  if (!(J() && ce() && ae()))
    return Qn();
}
function Qn() {
  var e = screen, n = function(r) {
    return H(pe(r), null);
  }, t = [n(e.width), n(e.height)];
  return t.sort().reverse(), t;
}
var _n = 2500, qn = 10, re, le;
function $n() {
  if (le === void 0) {
    var e = function() {
      var n = me();
      he(n) ? le = setTimeout(e, _n) : (re = n, le = void 0);
    };
    e();
  }
}
function et() {
  var e = this;
  return $n(), function() {
    return C(e, void 0, void 0, function() {
      var n;
      return F(this, function(t) {
        switch (t.label) {
          case 0:
            return n = me(), he(n) ? re ? [2, Ce([], re, !0)] : pn() ? [4, gn()] : [3, 2] : [3, 2];
          case 1:
            t.sent(), n = me(), t.label = 2;
          case 2:
            return he(n) || (re = n), [2, n];
        }
      });
    });
  };
}
function nt() {
  var e = this;
  if (J() && ce() && ae())
    return function() {
      return Promise.resolve(void 0);
    };
  var n = et();
  return function() {
    return C(e, void 0, void 0, function() {
      var t, r;
      return F(this, function(o) {
        switch (o.label) {
          case 0:
            return [4, n()];
          case 1:
            return t = o.sent(), r = function(i) {
              return i === null ? null : Re(i, qn);
            }, [2, [r(t[0]), r(t[1]), r(t[2]), r(t[3])]];
        }
      });
    });
  };
}
function me() {
  var e = screen;
  return [
    H(j(e.availTop), null),
    H(j(e.width) - j(e.availWidth) - H(j(e.availLeft), 0), null),
    H(j(e.height) - j(e.availHeight) - H(j(e.availTop), 0), null),
    H(j(e.availLeft), null)
  ];
}
function he(e) {
  for (var n = 0; n < 4; ++n)
    if (e[n])
      return !1;
  return !0;
}
function tt() {
  return H(pe(navigator.hardwareConcurrency), void 0);
}
function rt() {
  var e, n = (e = window.Intl) === null || e === void 0 ? void 0 : e.DateTimeFormat;
  if (n) {
    var t = new n().resolvedOptions().timeZone;
    if (t)
      return t;
  }
  var r = -it();
  return "UTC".concat(r >= 0 ? "+" : "").concat(Math.abs(r));
}
function it() {
  var e = new Date().getFullYear();
  return Math.max(
    j(new Date(e, 0, 1).getTimezoneOffset()),
    j(new Date(e, 6, 1).getTimezoneOffset())
  );
}
function ot() {
  try {
    return !!window.sessionStorage;
  } catch {
    return !0;
  }
}
function at() {
  try {
    return !!window.localStorage;
  } catch {
    return !0;
  }
}
function ct() {
  if (!(De() || dn()))
    try {
      return !!window.indexedDB;
    } catch {
      return !0;
    }
}
function st() {
  return !!window.openDatabase;
}
function ut() {
  return navigator.cpuClass;
}
function lt() {
  var e = navigator.platform;
  return e === "MacIntel" && J() && !be() ? hn() ? "iPad" : "iPhone" : e;
}
function ft() {
  return navigator.vendor || "";
}
function dt() {
  for (var e = [], n = 0, t = [
    "chrome",
    "safari",
    "__crWeb",
    "__gCrWeb",
    "yandex",
    "__yb",
    "__ybro",
    "__firefox__",
    "__edgeTrackingPreventionStatistics",
    "webkit",
    "oprt",
    "samsungAr",
    "ucweb",
    "UCShellJava",
    "puffinDevice"
  ]; n < t.length; n++) {
    var r = t[n], o = window[r];
    o && typeof o == "object" && e.push(r);
  }
  return e.sort();
}
function vt() {
  var e = document;
  try {
    e.cookie = "cookietest=1; SameSite=Strict;";
    var n = e.cookie.indexOf("cookietest=") !== -1;
    return e.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", n;
  } catch {
    return !1;
  }
}
function mt() {
  var e = atob;
  return {
    abpIndo: [
      "#Iklan-Melayang",
      "#Kolom-Iklan-728",
      "#SidebarIklan-wrapper",
      '[title="ALIENBOLA" i]',
      e("I0JveC1CYW5uZXItYWRz")
    ],
    abpvn: [".quangcao", "#mobileCatfish", e("LmNsb3NlLWFkcw=="), '[id^="bn_bottom_fixed_"]', "#pmadv"],
    adBlockFinland: [
      ".mainostila",
      e("LnNwb25zb3JpdA=="),
      ".ylamainos",
      e("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
    ],
    adBlockPersian: [
      "#navbar_notice_50",
      ".kadr",
      'TABLE[width="140px"]',
      "#divAgahi",
      e("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
    ],
    adBlockWarningRemoval: [
      "#adblock-honeypot",
      ".adblocker-root",
      ".wp_adblock_detect",
      e("LmhlYWRlci1ibG9ja2VkLWFk"),
      e("I2FkX2Jsb2NrZXI=")
    ],
    adGuardAnnoyances: [
      ".hs-sosyal",
      "#cookieconsentdiv",
      'div[class^="app_gdpr"]',
      ".as-oil",
      '[data-cypress="soft-push-notification-modal"]'
    ],
    adGuardBase: [
      ".BetterJsPopOverlay",
      e("I2FkXzMwMFgyNTA="),
      e("I2Jhbm5lcmZsb2F0MjI="),
      e("I2NhbXBhaWduLWJhbm5lcg=="),
      e("I0FkLUNvbnRlbnQ=")
    ],
    adGuardChinese: [
      e("LlppX2FkX2FfSA=="),
      e("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
      "#widget-quan",
      e("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
      e("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
    ],
    adGuardFrench: [
      "#pavePub",
      e("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
      ".mobile_adhesion",
      ".widgetadv",
      e("LmFkc19iYW4=")
    ],
    adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
    adGuardJapanese: [
      "#kauli_yad_1",
      e("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
      e("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
      e("LmFkZ29vZ2xl"),
      e("Ll9faXNib29zdFJldHVybkFk")
    ],
    adGuardMobile: [
      e("YW1wLWF1dG8tYWRz"),
      e("LmFtcF9hZA=="),
      'amp-embed[type="24smi"]',
      "#mgid_iframe1",
      e("I2FkX2ludmlld19hcmVh")
    ],
    adGuardRussian: [
      e("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
      e("LnJlY2xhbWE="),
      'div[id^="smi2adblock"]',
      e("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
      "#psyduckpockeball"
    ],
    adGuardSocial: [
      e("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
      e("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
      ".etsy-tweet",
      "#inlineShare",
      ".popup-social"
    ],
    adGuardSpanishPortuguese: ["#barraPublicidade", "#Publicidade", "#publiEspecial", "#queTooltip", ".cnt-publi"],
    adGuardTrackingProtection: [
      "#qoo-counter",
      e("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
      e("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
      "#top100counter"
    ],
    adGuardTurkish: [
      "#backkapat",
      e("I3Jla2xhbWk="),
      e("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
      e("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
      e("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
    ],
    bulgarian: [e("dGQjZnJlZW5ldF90YWJsZV9hZHM="), "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
    easyList: [
      ".yb-floorad",
      e("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
      e("LnRyYWZmaWNqdW5reS1hZA=="),
      ".textad_headline",
      e("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
    ],
    easyListChina: [
      e("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
      e("LmZyb250cGFnZUFkdk0="),
      "#taotaole",
      "#aafoot.top_box",
      ".cfa_popup"
    ],
    easyListCookie: [
      ".ezmob-footer",
      ".cc-CookieWarning",
      "[data-cookie-number]",
      e("LmF3LWNvb2tpZS1iYW5uZXI="),
      ".sygnal24-gdpr-modal-wrap"
    ],
    easyListCzechSlovak: [
      "#onlajny-stickers",
      e("I3Jla2xhbW5pLWJveA=="),
      e("LnJla2xhbWEtbWVnYWJvYXJk"),
      ".sklik",
      e("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
    ],
    easyListDutch: [
      e("I2FkdmVydGVudGll"),
      e("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
      ".adstekst",
      e("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
      "#semilo-lrectangle"
    ],
    easyListGermany: [
      "#SSpotIMPopSlider",
      e("LnNwb25zb3JsaW5rZ3J1ZW4="),
      e("I3dlcmJ1bmdza3k="),
      e("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
      e("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
    ],
    easyListItaly: [
      e("LmJveF9hZHZfYW5udW5jaQ=="),
      ".sb-box-pubbliredazionale",
      e("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
    ],
    easyListLithuania: [
      e("LnJla2xhbW9zX3RhcnBhcw=="),
      e("LnJla2xhbW9zX251b3JvZG9z"),
      e("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
      e("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
      e("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
    ],
    estonian: [e("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
    fanboyAnnoyances: ["#ac-lre-player", ".navigate-to-top", "#subscribe_popup", ".newsletter_holder", "#back-top"],
    fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
    fanboyEnhancedTrackers: [
      ".open.pushModal",
      "#issuem-leaky-paywall-articles-zero-remaining-nag",
      "#sovrn_container",
      'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
      ".BlockNag__Card"
    ],
    fanboySocial: ["#FollowUs", "#meteored_share", "#social_follow", ".article-sharer", ".community__social-desc"],
    frellwitSwedish: [
      e("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
      e("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
      "article.category-samarbete",
      e("ZGl2LmhvbGlkQWRz"),
      "ul.adsmodern"
    ],
    greekAdBlock: [
      e("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
      e("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
      e("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
      "DIV.agores300",
      "TABLE.advright"
    ],
    hungarian: [
      "#cemp_doboz",
      ".optimonk-iframe-container",
      e("LmFkX19tYWlu"),
      e("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
      "#hirdetesek_box"
    ],
    iDontCareAboutCookies: [
      '.alert-info[data-block-track*="CookieNotice"]',
      ".ModuleTemplateCookieIndicator",
      ".o--cookies--container",
      "#cookies-policy-sticky",
      "#stickyCookieBar"
    ],
    icelandicAbp: [e("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")],
    latvian: [
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="),
      e("YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ==")
    ],
    listKr: [
      e("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
      e("I2xpdmVyZUFkV3JhcHBlcg=="),
      e("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
      e("aW5zLmZhc3R2aWV3LWFk"),
      ".revenue_unit_item.dable"
    ],
    listeAr: [
      e("LmdlbWluaUxCMUFk"),
      ".right-and-left-sponsers",
      e("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
      e("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
      e("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
    ],
    listeFr: [
      e("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
      e("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
      e("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
      ".site-pub-interstitiel",
      'div[id^="crt-"][data-criteo-id]'
    ],
    officialPolish: [
      "#ceneo-placeholder-ceneo-12",
      e("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
      e("YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="),
      e("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
      e("ZGl2I3NrYXBpZWNfYWQ=")
    ],
    ro: [
      e("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
      e("YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="),
      e("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
      'a[href^="/url/"]'
    ],
    ruAd: [
      e("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
      e("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
      e("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
      "#pgeldiz",
      ".yandex-rtb-block"
    ],
    thaiAds: [
      "a[href*=macau-uta-popup]",
      e("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
      e("LmFkczMwMHM="),
      ".bumq",
      ".img-kosana"
    ],
    webAnnoyancesUltralist: [
      "#mod-social-share-2",
      "#social-tools",
      e("LmN0cGwtZnVsbGJhbm5lcg=="),
      ".zergnet-recommend",
      ".yt.btn-link.btn-md.btn"
    ]
  };
}
function ht(e) {
  var n = e === void 0 ? {} : e, t = n.debug;
  return C(this, void 0, void 0, function() {
    var r, o, i, a, c, s;
    return F(this, function(l) {
      switch (l.label) {
        case 0:
          return pt() ? (r = mt(), o = Object.keys(r), i = (s = []).concat.apply(s, o.map(function(f) {
            return r[f];
          })), [4, gt(i)]) : [2, void 0];
        case 1:
          return a = l.sent(), t && bt(r, a), c = o.filter(function(f) {
            var u = r[f], h = D(u.map(function(p) {
              return a[p];
            }));
            return h > u.length * 0.6;
          }), c.sort(), [2, c];
      }
    });
  });
}
function pt() {
  return J() || Ge();
}
function gt(e) {
  var n;
  return C(this, void 0, void 0, function() {
    var t, r, o, i, s, a, c, s;
    return F(this, function(l) {
      switch (l.label) {
        case 0:
          for (t = document, r = t.createElement("div"), o = new Array(e.length), i = {}, Ie(r), s = 0; s < e.length; ++s)
            a = bn(e[s]), a.tagName === "DIALOG" && a.show(), c = t.createElement("div"), Ie(c), c.appendChild(a), r.appendChild(c), o[s] = a;
          l.label = 1;
        case 1:
          return t.body ? [3, 3] : [4, K(50)];
        case 2:
          return l.sent(), [3, 1];
        case 3:
          return t.body.appendChild(r), [4, ie()];
        case 4:
          l.sent();
          try {
            for (s = 0; s < e.length; ++s)
              o[s].offsetParent || (i[e[s]] = !0);
          } finally {
            (n = r.parentNode) === null || n === void 0 || n.removeChild(r);
          }
          return [2, i];
      }
    });
  });
}
function Ie(e) {
  e.style.setProperty("visibility", "hidden", "important"), e.style.setProperty("display", "block", "important");
}
function bt(e, n) {
  for (var t = "DOM blockers debug:\n```", r = 0, o = Object.keys(e); r < o.length; r++) {
    var i = o[r];
    t += `
`.concat(i, ":");
    for (var a = 0, c = e[i]; a < c.length; a++) {
      var s = c[a];
      t += `
  `.concat(n[s] ? "\u{1F6AB}" : "\u27A1\uFE0F", " ").concat(s);
    }
  }
  console.log("".concat(t, "\n```"));
}
function yt() {
  for (var e = 0, n = ["rec2020", "p3", "srgb"]; e < n.length; e++) {
    var t = n[e];
    if (matchMedia("(color-gamut: ".concat(t, ")")).matches)
      return t;
  }
}
function wt() {
  if (xe("inverted"))
    return !0;
  if (xe("none"))
    return !1;
}
function xe(e) {
  return matchMedia("(inverted-colors: ".concat(e, ")")).matches;
}
function St() {
  if (Pe("active"))
    return !0;
  if (Pe("none"))
    return !1;
}
function Pe(e) {
  return matchMedia("(forced-colors: ".concat(e, ")")).matches;
}
var kt = 100;
function Lt() {
  if (!!matchMedia("(min-monochrome: 0)").matches) {
    for (var e = 0; e <= kt; ++e)
      if (matchMedia("(max-monochrome: ".concat(e, ")")).matches)
        return e;
    throw new Error("Too high value");
  }
}
function It() {
  if (q("no-preference"))
    return 0;
  if (q("high") || q("more"))
    return 1;
  if (q("low") || q("less"))
    return -1;
  if (q("forced"))
    return 10;
}
function q(e) {
  return matchMedia("(prefers-contrast: ".concat(e, ")")).matches;
}
function xt() {
  if (Ve("reduce"))
    return !0;
  if (Ve("no-preference"))
    return !1;
}
function Ve(e) {
  return matchMedia("(prefers-reduced-motion: ".concat(e, ")")).matches;
}
function Pt() {
  if (Ee("reduce"))
    return !0;
  if (Ee("no-preference"))
    return !1;
}
function Ee(e) {
  return matchMedia("(prefers-reduced-transparency: ".concat(e, ")")).matches;
}
function Vt() {
  if (Ae("high"))
    return !0;
  if (Ae("standard"))
    return !1;
}
function Ae(e) {
  return matchMedia("(dynamic-range: ".concat(e, ")")).matches;
}
var w = Math, R = function() {
  return 0;
};
function Et() {
  var e = w.acos || R, n = w.acosh || R, t = w.asin || R, r = w.asinh || R, o = w.atanh || R, i = w.atan || R, a = w.sin || R, c = w.sinh || R, s = w.cos || R, l = w.cosh || R, f = w.tan || R, u = w.tanh || R, h = w.exp || R, p = w.expm1 || R, A = w.log1p || R, I = function(y) {
    return w.pow(w.PI, y);
  }, b = function(y) {
    return w.log(y + w.sqrt(y * y - 1));
  }, S = function(y) {
    return w.log(y + w.sqrt(y * y + 1));
  }, x = function(y) {
    return w.log((1 + y) / (1 - y)) / 2;
  }, V = function(y) {
    return w.exp(y) - 1 / w.exp(y) / 2;
  }, E = function(y) {
    return (w.exp(y) + 1 / w.exp(y)) / 2;
  }, N = function(y) {
    return w.exp(y) - 1;
  }, Y = function(y) {
    return (w.exp(2 * y) - 1) / (w.exp(2 * y) + 1);
  }, X = function(y) {
    return w.log(1 + y);
  };
  return {
    acos: e(0.12312423423423424),
    acosh: n(1e308),
    acoshPf: b(1e154),
    asin: t(0.12312423423423424),
    asinh: r(1),
    asinhPf: S(1),
    atanh: o(0.5),
    atanhPf: x(0.5),
    atan: i(0.5),
    sin: a(-1e300),
    sinh: c(1),
    sinhPf: V(1),
    cos: s(10.000000000123),
    cosh: l(1),
    coshPf: E(1),
    tan: f(-1e300),
    tanh: u(1),
    tanhPf: Y(1),
    exp: h(1),
    expm1: p(1),
    expm1Pf: N(1),
    log1p: A(10),
    log1pPf: X(10),
    powPI: I(-100)
  };
}
var At = "mmMwWLliI0fiflO&1", fe = {
  default: [],
  apple: [{ font: "-apple-system-body" }],
  serif: [{ fontFamily: "serif" }],
  sans: [{ fontFamily: "sans-serif" }],
  mono: [{ fontFamily: "monospace" }],
  min: [{ fontSize: "1px" }],
  system: [{ fontFamily: "system-ui" }]
};
function Mt() {
  return Ct(function(e, n) {
    for (var t = {}, r = {}, o = 0, i = Object.keys(fe); o < i.length; o++) {
      var a = i[o], c = fe[a], s = c[0], l = s === void 0 ? {} : s, f = c[1], u = f === void 0 ? At : f, h = e.createElement("span");
      h.textContent = u, h.style.whiteSpace = "nowrap";
      for (var p = 0, A = Object.keys(l); p < A.length; p++) {
        var I = A[p], b = l[I];
        b !== void 0 && (h.style[I] = b);
      }
      t[a] = h, n.append(e.createElement("br"), h);
    }
    for (var S = 0, x = Object.keys(fe); S < x.length; S++) {
      var a = x[S];
      r[a] = t[a].getBoundingClientRect().width;
    }
    return r;
  });
}
function Ct(e, n) {
  return n === void 0 && (n = 4e3), Te(function(t, r) {
    var o = r.document, i = o.body, a = i.style;
    a.width = "".concat(n, "px"), a.webkitTextSizeAdjust = a.textSizeAdjust = "none", ge() ? i.style.zoom = "".concat(1 / r.devicePixelRatio) : J() && (i.style.zoom = "reset");
    var c = o.createElement("div");
    return c.textContent = Ce([], Array(n / 20 << 0), !0).map(function() {
      return "word";
    }).join(" "), i.appendChild(c), e(o, i);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
function Ft() {
  return navigator.pdfViewerEnabled;
}
function Wt() {
  var e = new Float32Array(1), n = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], n[3];
}
function Rt() {
  var e = window.ApplePaySession;
  if (typeof e?.canMakePayments != "function")
    return -1;
  try {
    return e.canMakePayments() ? 1 : 0;
  } catch (n) {
    return Dt(n);
  }
}
function Dt(e) {
  if (e instanceof Error) {
    if (e.name === "InvalidAccessError") {
      if (/\bfrom\b.*\binsecure\b/i.test(e.message))
        return -2;
      if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(e.message))
        return -3;
    }
    if (e.name === "SecurityError" && /\bthird.party iframes?.*\bnot.allowed\b/i.test(e.message))
      return -3;
  }
  throw e;
}
function Zt() {
  var e, n = document.createElement("a"), t = (e = n.attributionSourceId) !== null && e !== void 0 ? e : n.attributionsourceid;
  return t === void 0 ? void 0 : String(t);
}
var Ne = -1, Ye = -2, Gt = /* @__PURE__ */ new Set([
  10752,
  2849,
  2884,
  2885,
  2886,
  2928,
  2929,
  2930,
  2931,
  2932,
  2960,
  2961,
  2962,
  2963,
  2964,
  2965,
  2966,
  2967,
  2968,
  2978,
  3024,
  3042,
  3088,
  3089,
  3106,
  3107,
  32773,
  32777,
  32777,
  32823,
  32824,
  32936,
  32937,
  32938,
  32939,
  32968,
  32969,
  32970,
  32971,
  3317,
  33170,
  3333,
  3379,
  3386,
  33901,
  33902,
  34016,
  34024,
  34076,
  3408,
  3410,
  3411,
  3412,
  3413,
  3414,
  3415,
  34467,
  34816,
  34817,
  34818,
  34819,
  34877,
  34921,
  34930,
  35660,
  35661,
  35724,
  35738,
  35739,
  36003,
  36004,
  36005,
  36347,
  36348,
  36349,
  37440,
  37441,
  37443,
  7936,
  7937,
  7938
]), Tt = /* @__PURE__ */ new Set([
  34047,
  35723,
  36063,
  34852,
  34853,
  34854,
  34229,
  36392,
  36795,
  38449
]), jt = ["FRAGMENT_SHADER", "VERTEX_SHADER"], Nt = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], Xe = "WEBGL_debug_renderer_info";
function Yt(e) {
  var n, t, r, o, i, a, c = e.cache, s = He(c);
  if (!s)
    return Ne;
  if (!Ue(s))
    return Ye;
  var l = Be() ? null : s.getExtension(Xe);
  return {
    version: ((n = s.getParameter(s.VERSION)) === null || n === void 0 ? void 0 : n.toString()) || "",
    vendor: ((t = s.getParameter(s.VENDOR)) === null || t === void 0 ? void 0 : t.toString()) || "",
    vendorUnmasked: l ? (r = s.getParameter(l.UNMASKED_VENDOR_WEBGL)) === null || r === void 0 ? void 0 : r.toString() : "",
    renderer: ((o = s.getParameter(s.RENDERER)) === null || o === void 0 ? void 0 : o.toString()) || "",
    rendererUnmasked: l ? (i = s.getParameter(l.UNMASKED_RENDERER_WEBGL)) === null || i === void 0 ? void 0 : i.toString() : "",
    shadingLanguageVersion: ((a = s.getParameter(s.SHADING_LANGUAGE_VERSION)) === null || a === void 0 ? void 0 : a.toString()) || ""
  };
}
function Xt(e) {
  var n = e.cache, t = He(n);
  if (!t)
    return Ne;
  if (!Ue(t))
    return Ye;
  var r = t.getSupportedExtensions(), o = t.getContextAttributes(), i = [], a = [], c = [], s = [];
  if (o)
    for (var l = 0, f = Object.keys(o); l < f.length; l++) {
      var u = f[l];
      i.push("".concat(u, "=").concat(o[u]));
    }
  for (var h = Me(t), p = 0, A = h; p < A.length; p++) {
    var I = A[p], b = t[I];
    a.push("".concat(I, "=").concat(b).concat(Gt.has(b) ? "=".concat(t.getParameter(b)) : ""));
  }
  if (r)
    for (var S = 0, x = r; S < x.length; S++) {
      var V = x[S];
      if (!(V === Xe && Be())) {
        var E = t.getExtension(V);
        if (!!E)
          for (var N = 0, Y = Me(E); N < Y.length; N++) {
            var I = Y[N], b = E[I];
            c.push("".concat(I, "=").concat(b).concat(Tt.has(b) ? "=".concat(t.getParameter(b)) : ""));
          }
      }
    }
  for (var X = 0, y = jt; X < y.length; X++)
    for (var T = y[X], O = 0, B = Nt; O < B.length; O++) {
      var M = B[O], d = Ht(t, T, M);
      s.push("".concat(T, ".").concat(M, "=").concat(d.join(",")));
    }
  return c.sort(), a.sort(), {
    contextAttributes: i,
    parameters: a,
    shaderPrecisions: s,
    extensions: r,
    extensionParameters: c
  };
}
function He(e) {
  if (e.webgl)
    return e.webgl.context;
  var n = document.createElement("canvas"), t;
  n.addEventListener("webglCreateContextError", function() {
    return t = void 0;
  });
  for (var r = 0, o = ["webgl", "experimental-webgl"]; r < o.length; r++) {
    var i = o[r];
    try {
      t = n.getContext(i);
    } catch {
    }
    if (t)
      break;
  }
  return e.webgl = { context: t }, t;
}
function Ht(e, n, t) {
  var r = e.getShaderPrecisionFormat(e[n], e[t]);
  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
}
function Me(e) {
  var n = Object.keys(e.__proto__);
  return n.filter(Bt);
}
function Bt(e) {
  return typeof e == "string" && !e.match(/[^A-Z0-9_x]/);
}
function Be() {
  return Ze();
}
function Ue(e) {
  return typeof e.getParameter == "function";
}
var Ut = {
  fonts: Wn,
  domBlockers: ht,
  fontPreferences: Mt,
  audio: Ln,
  screenFrame: nt,
  canvas: Dn,
  osCpu: Un,
  languages: zn,
  colorDepth: Jn,
  deviceMemory: On,
  screenResolution: Kn,
  hardwareConcurrency: tt,
  timezone: rt,
  sessionStorage: ot,
  localStorage: at,
  indexedDB: ct,
  openDatabase: st,
  cpuClass: ut,
  platform: lt,
  plugins: Rn,
  touchSupport: Bn,
  vendor: ft,
  vendorFlavors: dt,
  cookiesEnabled: vt,
  colorGamut: yt,
  invertedColors: wt,
  forcedColors: St,
  monochrome: Lt,
  contrast: It,
  reducedMotion: xt,
  reducedTransparency: Pt,
  hdr: Vt,
  math: Et,
  pdfViewerEnabled: Ft,
  architecture: Wt,
  applePay: Rt,
  privateClickMeasurement: Zt,
  webGlBasics: Yt,
  webGlExtensions: Xt
};
function zt(e) {
  return fn(Ut, e, []);
}
var Jt = "$ if upgrade to Pro: https://fpjs.dev/pro";
function Ot(e) {
  var n = Kt(e), t = Qt(n);
  return { score: n, comment: Jt.replace(/\$/g, "".concat(t)) };
}
function Kt(e) {
  if (Ge())
    return 0.4;
  if (J())
    return be() && !(ce() && ae()) ? 0.5 : 0.3;
  var n = "value" in e.platform ? e.platform.value : "";
  return /^Win/.test(n) ? 0.6 : /^Mac/.test(n) ? 0.5 : 0.7;
}
function Qt(e) {
  return Re(0.99 + 0.01 * e, 1e-4);
}
function _t(e) {
  for (var n = "", t = 0, r = Object.keys(e).sort(); t < r.length; t++) {
    var o = r[t], i = e[o], a = "error" in i ? "error" : JSON.stringify(i.value);
    n += "".concat(n ? "|" : "").concat(o.replace(/([:|\\])/g, "\\$1"), ":").concat(a);
  }
  return n;
}
function ze(e) {
  return JSON.stringify(e, function(n, t) {
    return t instanceof Error ? cn(t) : t;
  }, 2);
}
function Je(e) {
  return an(_t(e));
}
function qt(e) {
  var n, t = Ot(e);
  return {
    get visitorId() {
      return n === void 0 && (n = Je(this.components)), n;
    },
    set visitorId(r) {
      n = r;
    },
    confidence: t,
    components: e,
    version: Fe
  };
}
function $t(e) {
  return e === void 0 && (e = 50), Qe(e, e * 2);
}
function er(e, n) {
  var t = Date.now();
  return {
    get: function(r) {
      return C(this, void 0, void 0, function() {
        var o, i, a;
        return F(this, function(c) {
          switch (c.label) {
            case 0:
              return o = Date.now(), [4, e()];
            case 1:
              return i = c.sent(), a = qt(i), (n || r?.debug) && console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(a.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(o - t, `
visitorId: `).concat(a.visitorId, `
components: `).concat(ze(i), "\n```")), [2, a];
          }
        });
      });
    }
  };
}
function nr() {
  if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
    try {
      var e = new XMLHttpRequest();
      e.open("get", "https://m1.openfpcdn.io/fingerprintjs/v".concat(Fe, "/npm-monitoring"), !0), e.send();
    } catch (n) {
      console.error(n);
    }
}
function tr(e) {
  var n;
  return e === void 0 && (e = {}), C(this, void 0, void 0, function() {
    var t, r, o;
    return F(this, function(i) {
      switch (i.label) {
        case 0:
          return (!((n = e.monitoring) !== null && n !== void 0) || n) && nr(), t = e.delayFallback, r = e.debug, [4, $t(t)];
        case 1:
          return i.sent(), o = zt({ cache: {}, debug: r }), [2, er(o, r)];
      }
    });
  });
}
var rr = { load: tr, hashComponents: Je, componentsToDebugString: ze };
const ir = "wingsSdk", $ = "items";
let de = "";
const or = (e, n, t = {}) => {
  switch (e) {
    case "setParams":
      return r();
    case "getParams":
      return o();
    case "subscribe":
      return i();
    case "update":
      return a();
    case "unsubscribe":
      return c();
    case "subscribeDevice":
      return s();
    case "updateDevice":
      return l();
    case "unsubscribeDevice":
      return f();
    case "getSubscription":
      return u();
    case "getSubscriptions":
      return h();
    case "getContent":
      return p();
    case "getHistory":
      return A();
    case "selfCheck":
      return I();
    case "getSourceAddress":
      return x();
    case "getDeviceId":
      return V();
    default:
      throw Error(`Method ${e} not found`);
  }
  async function r() {
    "baseUrl" in n && await B("baseUrl", n?.baseUrl ?? "");
  }
  async function o() {
    return { baseUrl: (await M("baseUrl"))?.value };
  }
  async function i() {
    if (!("publicKey" in n) || !n.publicKey)
      throw Error("publicKey not defined");
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    if (!("login" in n) || !n.login || !("password" in n) || !n.password)
      throw Error("login or password not defined");
    const { getSubscription: d } = se({ publicKey: n.publicKey }), m = await d(), v = await S(n.clientId, n?.deviceId), g = "clientUserDefinedProperties" in n ? n.clientUserDefinedProperties : void 0, k = "deviceUserDefinedProperties" in n ? n.deviceUserDefinedProperties : void 0, P = await X(), W = await Y(P?.publicKey);
    return await B("keys", P), await B("address", v), await B("authString", n.login + ":" + n.password), await E(
      "/webpush/v1/client?" + new URLSearchParams({ sourceAddress: v }).toString(),
      "POST",
      { client: { userDefinedProperties: g }, device: { subscription: m, userDefinedProperties: k }, pubKey: W },
      t
    );
  }
  async function a() {
    if (!("publicKey" in n) || !n.publicKey)
      throw Error("publicKey not defined");
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const d = await b(n.clientId), v = { client: { userDefinedProperties: "clientUserDefinedProperties" in n ? n.clientUserDefinedProperties : void 0 } }, g = await M("keys");
    if (!g)
      throw Error("Keys not found. Subscribe first.");
    const k = await T({ sourceAddress: d, ...v }, g?.value?.privateKey);
    return await E(
      "/webpush/v1/client?" + new URLSearchParams({ sourceAddress: d, signature: k }).toString(),
      "PUT",
      v,
      t
    );
  }
  async function c() {
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const d = await b(n.clientId), m = await M("keys");
    if (!m)
      throw Error("Keys not found. Subscribe first.");
    const v = await T({ sourceAddress: d }, m?.value?.privateKey);
    return await E(
      "/webpush/v1/client?" + new URLSearchParams({ sourceAddress: d, signature: v }).toString(),
      "DELETE",
      {},
      t
    );
  }
  async function s() {
    if (!("publicKey" in n) || !n.publicKey)
      throw Error("publicKey not defined");
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const { getSubscription: d } = se({ publicKey: n.publicKey }), m = await d(), v = await b(n.clientId), g = "deviceUserDefinedProperties" in n ? n.deviceUserDefinedProperties : void 0, k = await X(), P = await Y(k?.publicKey);
    return await B("keys", k), await E(
      "/webpush/v1/client/device?" + new URLSearchParams({ sourceAddress: v }).toString(),
      "POST",
      { device: { subscription: m, userDefinedProperties: g }, pubKey: P },
      t
    );
  }
  async function l() {
    if (!("publicKey" in n) || !n.publicKey)
      throw Error("publicKey not defined");
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const { getSubscription: d } = se({ publicKey: n.publicKey }), m = (await d())?.toJSON(), v = await b(n.clientId), g = n?.destinationAddress, k = "deviceUserDefinedProperties" in n ? n.deviceUserDefinedProperties : void 0, P = { device: { subscription: m, userDefinedProperties: k } };
    let W = { sourceAddress: v };
    g && (W.destinationAddress = g);
    const U = await M("keys");
    if (!U)
      throw Error("Keys not found. Subscribe first.");
    const Oe = await T({ ...W, ...P }, U?.value?.privateKey);
    return await E(
      "/webpush/v1/client/device?" + new URLSearchParams({ ...W, signature: Oe }).toString(),
      "PUT",
      P,
      t
    );
  }
  async function f() {
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const d = await b(n.clientId), m = n?.destinationAddress, v = m ? { sourceAddress: d, destinationAddress: m } : { sourceAddress: d }, g = await M("keys");
    if (!g)
      throw Error("Keys not found. Subscribe first.");
    const k = await T({ sourceAddress: d }, g?.value?.privateKey);
    return await E(
      "/webpush/v1/client/device",
      "DELETE",
      { ...v, signature: k },
      t
    );
  }
  async function u() {
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const d = await b(n.clientId), m = { sourceAddress: d, destinationAddress: d }, v = await M("keys");
    if (!v)
      throw Error("Keys not found. Subscribe first.");
    const g = await T(m, v?.value?.privateKey);
    return await E(
      "/webpush/v1/client/device",
      "GET",
      { ...m, signature: g },
      t
    );
  }
  async function h() {
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    const m = { sourceAddress: await b(n.clientId), destinationAddress: n.clientId }, v = await M("keys");
    if (!v)
      throw Error("Keys not found. Subscribe first.");
    const g = await T(m, v?.value?.privateKey);
    return await E(
      "/webpush/v1/client/device",
      "GET",
      { ...m, signature: g },
      t
    );
  }
  async function p() {
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    if (!("pushMessageId" in n) || !n.pushMessageId)
      throw Error("pushMessageId not defined");
    const d = await b(n.clientId), m = n.pushMessageId, v = { sourceAddress: d, pushMessageId: m }, g = await M("keys");
    if (!g)
      throw Error("Keys not found. Subscribe first.");
    const k = await T(v, g?.value?.privateKey);
    return await E(
      "/webpush/v1/content/download",
      "GET",
      { ...v, signature: k },
      t
    );
  }
  async function A() {
    if (!("clientId" in n) || !n.clientId)
      throw Error("clientId not defined");
    let d = {};
    "channels" in n && n?.channels?.length > 0 && (d = { ...n, channels: n?.channels?.join(",") });
    let v = { sourceAddress: await b(n.clientId), ...d };
    delete v.clientId;
    const g = await M("keys");
    if (!g)
      throw Error("Keys not found. Subscribe first.");
    const k = await T(v, g?.value?.privateKey);
    return await E(
      "/webpush/v1/messages/get/history",
      "GET",
      { ...v, signature: k },
      t
    );
  }
  async function I() {
    const d = await h();
    return console.log("selfCheck res", d), !!d;
  }
  async function b(d, m = "") {
    const v = await M("address");
    return v && v?.value ? v.value : (m || (m = await V()), m + "." + d);
  }
  async function S(d, m) {
    return m || (m = await V()), m + "." + d;
  }
  async function x() {
    return (await M("address"))?.value;
  }
  async function V() {
    return de || (de = (await (await rr.load()).get()).visitorId), de;
  }
  async function E(d = "", m = "GET", v = {}, g = {}) {
    ["GET", "DELETE"].includes(m) && (d += "?" + new URLSearchParams(v).toString());
    const k = (await M("baseUrl"))?.value ?? "", P = (await M("authString"))?.value;
    g.Authorization = "Basic " + btoa(P), g["Content-Type"] = "application/json";
    const W = await fetch(k + d, {
      method: m,
      headers: g,
      body: ["GET", "DELETE"].includes(m) ? null : JSON.stringify(v)
    });
    if (!W.ok)
      throw await W.json();
    return W.status === 204 ? W : await W.json();
  }
  function N(d) {
    return String.fromCharCode.apply(null, new Uint8Array(d));
  }
  async function Y(d) {
    const m = await window.crypto.subtle.exportKey("spki", d);
    return window.btoa(N(m));
  }
  async function X() {
    return await window.crypto.subtle.generateKey(
      {
        name: "RSASSA-PKCS1-v1_5",
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: "SHA-256"
      },
      !0,
      ["sign", "verify"]
    );
  }
  function y(d) {
    function m(k, P) {
      for (const [W, U] of Object.entries(k))
        U != null && typeof U == "object" ? m(U, P) : P[W] = U;
    }
    let v = {};
    m(d, v);
    let g = "";
    return "sourceAddress" in v && (g += v.sourceAddress, delete v.sourceAddress), "destinationAddress" in v && (g += v.destinationAddress, delete v.destinationAddress), "pushMessageId" in v && (g += v.pushMessageId, delete v.pushMessageId), Object.keys(v).sort().reduce((k, P) => (g += P + "" + v[P], k), {}), console.log("String to sign", d, g), g;
  }
  async function T(d, m) {
    typeof d == "object" && (d = y(d));
    const v = await window.crypto.subtle.sign(
      {
        name: "RSASSA-PKCS1-v1_5",
        saltLength: 32
      },
      m,
      new TextEncoder().encode(d)
    );
    return window.btoa(N(v));
  }
  function O(d) {
    let m = window.indexedDB.open(ir, 1);
    m.onerror = function(v) {
      console.log(v);
    }, m.onsuccess = function() {
      d(m.result);
    }, m.onupgradeneeded = function(v) {
      v?.target?.result?.createObjectStore($, { keyPath: "key" }), O(d);
    };
  }
  function B(d, m) {
    return new Promise((v, g) => {
      O(function(k) {
        var P = k.transaction([$], "readwrite").objectStore($).put({ key: d, value: m });
        P.onerror = function(W) {
          g(W);
        }, P.onsuccess = function() {
          v(P.result);
        };
      });
    });
  }
  async function M(d) {
    return new Promise((m, v) => {
      O(function(g) {
        var k = g.transaction([$], "readonly").objectStore($).get(d);
        k.onerror = function(P) {
          v(P);
        }, k.onsuccess = function() {
          m(k.result);
        };
      });
    });
  }
};
export {
  or as wingsSdk
};
